import { useSelector } from "react-redux";
import moment from "moment";

export const useDateFormatter = () => {

    const business = useSelector((state) => state.businesses.business);

    const formatDateString = business?.country?.jsLongDateFormat || "MMM DD, YYYY";
    const formatTimeString = business?.country?.jsTimeFormat || "HH:mm A";
    const formatDateTimeString = business?.country?.jsLongDateTimeFormat || "MMM DD, YYYY HH:mm";

    const formatDate = (date) => {
        if (!date) return "";
        return moment(date).format(formatDateString);
    };

    const formatApiDate = (date) => {
        if (!date) return "";
        return moment(date).format("YYYY-MM-DD");
    };

    const formatTime = (time) => {
        if (!time) return "";
        return moment(time).format(formatTimeString)
    }

    const formatDateTime = (dateTime) => {
        if (!dateTime) return "";
        return moment(dateTime).format(formatDateTimeString);
    };

    const formatCustomDateTime = (date) => {
        if (!date) return "";
        return moment(date).format("ll, HH:mm -- ");
    };

    return { formatDate, formatApiDate, formatTime, formatDateTime, formatCustomDateTime };
};